module.exports = __webpack_public_path__ + "img/epl.dacee302.png";